const _excluded = ["regionId"];var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}function _objectWithoutProperties(e, t) {if (null == e) return {};var o,r,i = _objectWithoutPropertiesLoose(e, t);if (Object.getOwnPropertySymbols) {var s = Object.getOwnPropertySymbols(e);for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);}return i;}function _objectWithoutPropertiesLoose(r, e) {if (null == r) return {};var t = {};for (var n in r) if ({}.hasOwnProperty.call(r, n)) {if (e.includes(n)) continue;t[n] = r[n];}return t;}import "../scss/conversion_base.scss";
import "../scss/document.scss";

import PropTypes from 'prop-types';
import React, { Component, createRef } from 'react';

import { Loader } from "../../components/Elements/Loader";
import { PDF } from "../../PDF";
import Immutable from 'immutable';
import { highlightSnippet } from "../actions/uiActions";
import { selectionHandlers } from "../../V2/Components/PDFViewer";
import { atomStore, pdfScaleAtom } from "../../V2/atoms";

import determineDirection from "../utils/determineDirection";

import { APIURL } from "../../config.js";

class Document extends Component {
  constructor(props) {
    super(props);
    //TODO: remove this if this is not needed anymore
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.pages = { 1: 0 };
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.previousMostVisible = props.page;
    this.pdfLoaded = this.pdfLoaded.bind(this);
    this.onDocumentReady = this.onDocumentReady.bind(this);
    this.onTextDeselection = this.onTextDeselection.bind(this);
    this.onTextSelected = this.onTextSelected.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.highlightReference = this.highlightReference.bind(this);
    this.containerRef = /*#__PURE__*/createRef();
  }

  componentDidUpdate(prevProps) {
    if (prevProps && prevProps.doc.get('_id') !== this.props.doc.get('_id')) {
      this.props.unsetSelection();
    }
    highlightSnippet(this.props.selectedSnippet, this.props.searchTerm);
  }

  onTextSelected(textSelection) {
    if (this.props.disableTextSelection) {
      return;
    }
    const selectionRectangles = textSelection.selectionRectangles.map(
      (_ref) => {let { regionId } = _ref,otherProps = _objectWithoutProperties(_ref, _excluded);return _objectSpread(_objectSpread({}, otherProps), {}, { page: regionId });}
    );
    const highlight = selectionHandlers.adjustSelectionsToScale(_objectSpread(_objectSpread({},
    textSelection), {}, { selectionRectangles }),
    atomStore.get(pdfScaleAtom),
    true
    );
    this.props.setSelection(highlight, this.props.file._id);
    this.props.deactivateReference();
  }

  onTextDeselection() {
    this.props.unsetSelection();
  }

  onDocumentReady() {
    this.props.onDocumentReady(this.props.doc);
  }

  handleClick() {
    if (this.props.executeOnClickHandler) {
      this.props.onClick();
    }
  }

  highlightReference(connection, referenceGroup) {
    return this.props.activateReference(
      connection,
      referenceGroup,
      undefined,
      undefined,
      !this.props.disableTextSelection
    );
  }

  pdfLoaded() {
    if (this.props.doScrollToActive) {
      const references = this.props.references.toJS();
      this.props.scrollToActive(
        references.find((r) => r._id === this.props.activeReference),
        references,
        this.props.doScrollToActive
      );
    }
    this.props.onPDFLoaded();
    this.componentDidUpdate();
  }

  handleOver() {}

  renderPDF(file) {
    if (!file._id && this.containerRef) {
      return /*#__PURE__*/_jsx(Loader, {});
    }

    return (/*#__PURE__*/
      _jsx(PDF, {
        onPageChange: this.props.onPageChange,
        onPDFReady: this.onDocumentReady,
        onPageLoaded: this.props.onPageLoaded,
        onLoad: this.pdfLoaded,
        file: `${APIURL}files/${file.filename}`,
        filename: file.filename,
        onTextSelection: this.onTextSelected,
        onTextDeselection: this.onTextDeselection,
        highlightReference: this.highlightReference,
        activeReference: this.props.activeReference,

        parentRef: this.containerRef }, file.filename
      ));

  }

  render() {
    const { file } = this.props;
    const Header = this.props.header;

    return (/*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", {
        className: `_${this.props.doc.get('_id')} document ${
        this.props.className} ${
        determineDirection(file)}` }, void 0, /*#__PURE__*/

      _jsx(Header, {}), /*#__PURE__*/
      React.createElement("div", {
        className: "pages",
        ref: this.containerRef,
        onMouseOver: this.handleOver.bind(this),
        onClick: this.handleClick },

      this.renderPDF(file)
      )
      )
      ));

  }
}

Document.defaultProps = {
  onPageLoaded: () => {},
  onDocumentReady: () => {},
  onPageChange: () => {},
  onClick: () => {},
  onPDFLoaded: () => {},
  file: {},
  searchTerm: '',
  page: 1,
  selectedSnippet: Immutable.fromJS({}),
  deactivateReference: () => {},
  header: () => false,
  activateReference: () => {},
  doScrollToActive: false,
  scrollToActive: () => {},
  activeReference: '',
  className: '',
  executeOnClickHandler: false
};


























export { Document };

export default Document;